module.exports = __webpack_public_path__ + "img/persona dreamdeal tech.1471994c.png";